export const newsConstants = {
    SEARCH_REQUEST: 'NEWS_SEARCH_REQUEST',
    SEARCH_SUCCESS: 'NEWS_SEARCH_SUCCESS',
    SEARCH_CLEAR: 'NEWS_SEARCH_CLEAR',
    SEARCH_FAILURE: 'NEWS_SEARCH_FAILURE',
    SEARCH_FAILURE_DONE: 'NEWS_SEARCH_FAILURE_DONE',
};